<template>
  <div class="row align-items-center justify-content-end">
    <div class="col-auto d-flex align-items-center flex-nowrap">
      <div v-if="storeGlobal.permisos.rrss.showed" class="col-auto me-2">
        <div class="hvr-grow social-icon">
          <a
            :href="instagram"
            target="_blank"
            class="social-icon-link shadow"
            aria-label="Instragram link">
            <CustomIcon :icon="instagramIcon" size="20px" :class="isLanding ? 'landing-header-icon' : 'text-primary'" />
          </a>
        </div>
      </div>
      <div v-if="storeGlobal.permisos.rrss.showed" class="col-auto me-2">
        <div class="hvr-grow social-icon">
          <a
            :href="tiktok"
            target="_blank"
            class="social-icon-link shadow"
            aria-label="TikTok link">
            <CustomIcon :icon="tiktokIcon" size="20px" :class="isLanding ? 'landing-header-icon' : 'text-primary'" />
          </a>
        </div>
      </div>

      <template v-if="isRoigarenaOrTransviagoDomain">
        <div class="caja-info-roigarena shadow social-icon me-2">
          <span class="horario-text">{{ $t('header.soporteTuristico') }} {{ $t('header.horarioContacto') }}</span>
          <span class="separator-vertical-roigarena"></span>
          <CustomIcon :icon="emailIcon" size="16px" class="flex-shrink-0" />
          <span class="mx-2">{{ agenciaStore.email }}</span>
          <template v-if="phoneNumber">
            <span class="separator-vertical-roigarena"></span>
            <CustomIcon :icon="whatsappIcon" size="20px" class="flex-shrink-0" />
            <span class="mx-2">{{ phoneNumber }}</span>
          </template>
        </div>
      </template>
      <template v-else>
        <div v-if="agenciaStore.email" class="caja-info social-icon email-container me-2">
          <CustomIcon :icon="emailIcon" size="16px" :class="isLanding ? 'landing-header-icon' : 'text-primary'" />
          <span class="mx-2">{{ agenciaStore.email }}</span>
        </div>
        <template v-if="phoneNumber || agenciaStore.contactScheduleCustomerService">
          <div class="caja-info">
            <template v-if="phoneNumber">
              <CustomIcon
                :icon="whatsappIcon"
                size="20px"
                :class="isLanding ? 'landing-header-icon' : 'text-primary'" />
              <span class="ms-2">{{ phoneNumber }}</span>
            </template>
            <div v-if="phoneNumber && agenciaStore.contactScheduleCustomerService" class="separator-vertical"></div>
            <span v-if="agenciaStore.contactScheduleCustomerService">
              {{ agenciaStore.contactScheduleCustomerService }}
            </span>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup>
  import { instagram, tiktok } from '@/constants/socialMedias';
  import { appGlobalStore } from '@/store_pinia/app';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import { computed } from 'vue';
  import { checkDomain, DOMAINS } from '@/helpers/domainUtils';
  import CustomIcon from '@/components/CustomIcon.vue';
  import emailIcon from '@/assets/icons/raw/email.svg';
  import whatsappIcon from '@/assets/icons/raw/whatsapp.svg';
  import instagramIcon from '@/assets/icons/instagram.svg';
  import tiktokIcon from '@/assets/icons/tiktok.svg';
  import router from '@/router';
  import { GruposInformacionViaje, AgrupacionDetalle } from '@/router/RouterNames';

  const agenciaStore = agenciaStoreModule();
  const storeGlobal = appGlobalStore();

  const isLanding = computed(() =>
    [GruposInformacionViaje, AgrupacionDetalle].includes(router.currentRoute.value.name)
  );

  const phoneNumber = computed(() => {
    return agenciaStore.getTelefono?.toString();
  });

  const isRoigarenaDomain = computed(() => checkDomain([DOMAINS.roigarena]));
  const isTransviagoDomain = computed(() => checkDomain([DOMAINS.transviago]));
  const isRoigarenaOrTransviagoDomain = computed(() => isRoigarenaDomain.value || isTransviagoDomain.value);
</script>

<style scoped lang="css">
  .social-icon-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    border-radius: 50%;
    overflow: hidden;
    background-color: rgba(255, 255, 255, 0.7);
  }

  .caja-info {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 10px;
    border-radius: 6px;
    box-shadow: 4px 6px 20px 0px var(--bs-primary-rgb, 0.05), 2px 4px 5px 0px var(--bs-primary-rgb, 0.05),
      0px 0px 1px 0px var(--bs-primary-rgb, 0.3) !important;
    background-color: rgba(255, 255, 255, 0.5);
  }

  .email-container {
    margin-right: 0.5rem;
  }

  .landing-header-icon {
    color: var(--landing-header-color);
  }

  .caja-info-roigarena {
    font-size: 0.8rem !important;
    text-align: center !important;
    font-weight: 400 !important;
    display: flex !important;
    padding: 9px 10px !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 8px !important;
    border-radius: 20px !important;
    background: #df5312 !important;
    background-color: #df5312 !important;
    color: #ffffff !important;
  }

  .caja-info-roigarena * {
    color: #ffffff !important;
  }

  .caja-info-roigarena i,
  .caja-info-roigarena span {
    color: #ffffff !important;
  }

  .separator-vertical-roigarena {
    width: 1px;
    height: 20px;
    background-color: rgba(255, 255, 255, 0.3);
    flex-shrink: 0;
  }

  .horario-text {
    padding-left: 5px;
    padding-right: 5px;
  }

  .separator-vertical {
    width: 1px;
    height: 15px;
    background-color: rgba(var(--bs-primary-rgb), 0.3);
    flex-shrink: 0;
    margin: 0 8px;
  }
</style>
